import { useEffect, useState, type ReactNode } from "react";

import { applyUpdate, subscribeToUpdates } from "../sw-register.ts";
import { Icon } from "./Icon.tsx";

/**
 * El aviso de version nueva (SPEC 15.7): discreto, abajo, y con la recarga
 * SIEMPRE en manos del usuario. Puede haber medio formulario de alta escrito.
 *
 * Se puede cerrar. Un aviso que no se deja cerrar acaba siendo un trozo de
 * pantalla que el usuario ya no recupera hasta que ceda, y la version vieja
 * sigue funcionando: lo unico que pasa por no recargar es que sigue siendo la
 * de ayer.
 */
export function UpdateToast(): ReactNode {
  const [ready, setReady] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => subscribeToUpdates(setReady), []);

  if (!ready || dismissed) return null;

  return (
    <div className="toast toast-update show" role="status" aria-live="polite">
      <Icon name="sparkles" />
      <span>Hay una version nueva.</span>
      <button type="button" className="btn sm toast-action" onClick={applyUpdate}>
        Recargar
      </button>
      <button
        type="button"
        className="toast-close"
        aria-label="Cerrar el aviso"
        onClick={() => {
          setDismissed(true);
        }}
      >
        <Icon name="x" />
      </button>
    </div>
  );
}
